(function($/*, window, document*/) {
	// useful for toggling active classes on buttons
	$.fn.makeActive = function() {
		var $el = this;
		$el.siblings().each(function() {
			$(this)
				.removeClass('active');
		});

		$el
			.addClass('active');
		return $el;
	};

	$.getQueryStrings = function() {
		var queryString = window.location.search.substring(1);
		return parseQueryString(queryString);
	};

	$.getHashParams = function() {
		var queryString = window.location.hash.substring(1);
		return parseQueryString(queryString);
	};

	// strange place to put this, but i think it's the only place that has
	// access to everything we need before pagemanager and resolveurl are included
	$.getF2Url = function() {
		var f2Url = '~/F2/Apps/json?t=1';
		var queryString = $.getQueryStrings();

		for (var prop in queryString) {
			if (queryString.hasOwnProperty(prop) && prop.substr(0,2) === '..') {
				f2Url += encodeURI('&' + prop + '=' + queryString[prop]);
			}
		}

		return f2Url;
	};

	$.fn.hiddenWidth = function() {
		var $hiddenParent = this.parents(':hidden').last();

		$hiddenParent.addClass('visability-hidden');

		var width = this.width();

		$hiddenParent.removeClass('visability-hidden');

		return width;
	};

	//
	// settings is an object that contains:
	//
	// - symbol (string, optional): if present and no xid present, xref does a symbol
	// search before looking for the quote data. NOTE: XID or SYMBOL need to be present.
	//
	// - xid (string, optional): if present, xref uses this to search instead
	// of doing a symbol search. NOTE: XID or SYMBOL need to be present.
	//
	// - asOfDateFormat (string, optional): default on server, c# String.Format string to use
	// to return the asOfDate. "{0}" gets replaced with the DateTime.
	//		- example:
	//			"As of {0}" becomes:
	//			"As of Nov 10, 2014 at 1:29 PM"
	//
	// - isOption (bool, optional, default: false): if true, call the option chain lookup
	// instead of the snap quote lookup
	//
	//$.requestSnapQuote = function(settings) {

	//	if (typeof settings.Symbol === "undefined" && typeof settings.Xid === "undefined") {
	//		alert("Cannot retrieve quote data.");
	//	}

	//	settings.isOption = typeof settings.IsOption === "undefined"
	//		? settings.IsOption
	//		: false;

	//	return $.ajax({
	//		url: settings.IsOption
	//			? "~/API/GetOptionQuote".resolveUrl()
	//			: "~/API/GetSnapQuote".resolveUrl(),
	//		data: {
	//			symbol: settings.Symbol,
	//			xid: settings.Xid,
	//			asOfDateFormat: settings.AsOfDateFormat
	//		},
	//		type: 'POST',
	//		dataType: 'json'
	//	});
	//};

	//$.requestAutoComplete = function(searchFor) {
	//	return $.ajax({
	//		url: "~/API/AutoCompleteSearch".resolveUrl(),
	//		data: {
	//			searchFor: searchFor
	//		},
	//		type: 'POST',
	//		dataType: 'json'
	//	});
	//};

	//$.requestPdfDocumentModal = function(documentKey) {
	//	var url =
	//		(window.location.protocol + "//" + window.location.hostname) +
	//		("~/Report/" + documentKey).resolveUrl();

	//	return MOD.WfEasyXdm.channel.postMessage("PDF_" + url);
	//};

	$.fn.showTooltip = function() {
		this.each(function() {
			var tooltipId = $(this).attr('aria-describedby');
			var $tooltip = $('#' + tooltipId);

			$tooltip.show();
			$tooltip.attr('tabindex', 0).focus();
			$tooltip.addClass('mk-tooltip-manual');
			$tooltip.blur(function() {
				$tooltip.hide();
			});
		});

		return this;
	};

	$.fn.truncate = function() {
		return $(this)
			.filter(function() {return $(this).data('dotdotdot') === undefined;})
			.dotdotdot({
				watch: true,
				fallbackToLetter: false,
				after: ".ddd-keep",
				tolerance: 3 // Selected empirically
			});
	};

	function parseQueryString(string) {
		var assoc = {};
		var decode = function(s) { return decodeURIComponent(s.replace(/\+/g, ' ')); };
		var keyValues = string.split('&');

		for (var i in keyValues) {
			if (!string.hasOwnProperty(i)) {
				continue;
			}

			var key = keyValues[i].split('=');
			if (key.length > 1) {
				assoc[decode(key[0]).toLowerCase()] = decode(key[1]);
			}
		}

		return assoc;
	}

	//Additional selectors
	$.extend($.expr[':'], {
		data: function (elem, i, match) {
			return !!$.data(elem, match[3]);
		},

		focusable: function (element) {
			var nodeName = element.nodeName.toLowerCase(),
				tabIndex = $.attr(element, 'tabindex');
			return (/input|select|textarea|button|object/.test(nodeName)
				? !element.disabled
				: 'a' == nodeName || 'area' == nodeName
					? element.href || !isNaN(tabIndex)
					: !isNaN(tabIndex))
				// the element and all of its ancestors must be visible
				// the browser may report that the area is hidden
				&& !$(element)['area' == nodeName ? 'parents' : 'closest'](':hidden').length;
		},

		tabbable: function (element) {
			var tabIndex = $.attr(element, 'tabindex');
			return (isNaN(tabIndex) || tabIndex >= 0) && $(element).is(':focusable');
		}
	});

})(jQuery/*, window, document*/);
